export default __webpack_public_path__ + "7e4ed3855008cacc24ec408da1f8c4a9.png";